export default "__VITE_ASSET__DDn0weL3__"